import { registerPlugin } from '@capacitor/core';
import type { InstagramStoriesPlugin } from './InstagramStoriesDefinitions';

const InstagramStories = registerPlugin<InstagramStoriesPlugin>('InstagramStoriesPlugin', {
  web: () => import('./InstagramStoriesWeb').then(m => new m.InstagramStoriesPluginWeb()),
});

export * from './InstagramStoriesDefinitions';
export default InstagramStories;
